// import axios from "axios"
// import { getKey, subscribeKey } from "./services/home"


// function urlBase64ToUint8Array(base64String) {
//     const padding = "=".repeat((4 - base64String.length % 4) % 4)
//     // eslint-disable-next-line
//     const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/")

//     const rawData = window.atob(base64)
//     const outputArray = new Uint8Array(rawData.length)

//     for (let i = 0; i < rawData.length; ++i) {
//         outputArray[i] = rawData.charCodeAt(i)
//     }
//     return outputArray
// }

// export function subscriptionNotification() {
//     if ('serviceWorker' in navigator) {
//         navigator.serviceWorker.ready.then(function (registration) {
//             if (!registration.pushManager) {
//                 console.log('Push manager unavailable.')
//                 return
//             }

//             registration.pushManager.getSubscription().then(function (existedSubscription) {
//                 if (existedSubscription === null) {
//                     console.log('No subscription detected, make a request.')

//                     getKey().then(key => {
//                         console.log(key,"key")
//                         registration.pushManager.subscribe({
//                             applicationServerKey: urlBase64ToUint8Array(key.data.response),
//                             userVisibleOnly: true,
//                         }).then(function (newSubscription) {
//                             console.log('New subscription added.')
//                             subscribeKey(newSubscription).then(res => {
//                                 console.log(res, "res11111")
//                                 return res
//                             }).catch((err) => {
//                                 console.log(err, "errrrrrr")
//                                 return err
//                             })
//                         }).catch(function (e) {
//                             if (Notification.permission !== 'granted') {
//                                 console.log('Permission was not granted.')
//                             } else {
//                                 console.error('An error ocurred during the subscription process.', e)
//                             }
//                         })
//                     })
//                 } else {
//                     console.log('Existed subscription detected.')
//                     subscribeKey(existedSubscription).then(res => {
//                         console.log(res, "res11111")
//                         return res
//                     }).catch((err) => {
//                         console.log(err, "errrrrrr")
//                         return err
//                     })
//                 }
//             })
//         })
//             .catch(function (e) {
//                 console.error('An error ocurred during Service Worker registration.', e)
//             })
//     }
// }

import axios from "axios";
import { getKey, subscribeKey } from "./services/home";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export async function subscriptionNotification() {
  try {
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.ready;

      if (!registration.pushManager) {
        console.log("Push manager unavailable.");
        return;
      }

      const existedSubscription = await registration.pushManager.getSubscription();

      if (existedSubscription === null) {
        console.log("No subscription detected, make a request.");

        const key = await getKey();
        console.log(key, "key");

        const newSubscription = await registration.pushManager.subscribe({
          applicationServerKey: urlBase64ToUint8Array(key),
          userVisibleOnly: true,
        });

        const payload = {
          subcription : newSubscription,
          publicKey : key
        }

        console.log("New subscription added.");
        const res = await subscribeKey(payload);
        console.log(res, "res11111");
        return res;
      } 
      // else {
      //   console.log("Existed subscription detected.");
      //   const res = await subscribeKey(existedSubscription);
      //   console.log(res, "res11111");
      //   return res;
      // }
    }
  } catch (error) {
    console.error("An error occurred:", error);
  }
}
